module.exports = __webpack_public_path__ + "media/images/official/special_hopper_terashima_01-a5cb8c714527dc2c218167b9d3fc4f7d.png";